// define request and or response interceptors
export function PatchInterceptor() {
	'ngInject';
	return {
		request: config => {
			// manipulate config or config.data
			if (config.method && config.method.toUpperCase() == 'PATCH') {
				config.method = 'POST';
				config.headers['X-HTTP-Method-Override'] = 'PATCH';
			}
			return config;
		},
	};
}
